import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import chestPurple from '../../assets/images/chest-purple.png';
import mysteryBoxBg from '../../assets/images/mystery-box-bg.png';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const RouletteSlide = ({ navigate }) => (
  <button onClick={() => navigate('/roleta')} data-testid="roulette-home-banner"
    className="w-full group relative overflow-hidden rounded-2xl border border-blue-400/50 shadow-lg shadow-blue-900/30 transition-transform hover:scale-[1.01]"
    style={{ background: 'linear-gradient(100deg, #0a1450 0%, #14309e 55%, #0a1450 100%)' }}>
    <div className="flex items-center justify-between gap-3 px-4 sm:px-6 py-3.5">
      <div className="flex items-center gap-3 text-left">
        <img src="/roleta/banner_wheel.png" alt="" className="w-12 h-12 drop-shadow-lg"
          style={{ animation: 'banner-wheel-spin 6s linear infinite' }} />
        <div>
          <p className="text-white font-black text-sm sm:text-base leading-tight">
            ROLETA DAS <span className="text-yellow-300">AZULZINHAS</span>
          </p>
          <p className="text-blue-200 text-[11px] sm:text-xs">
            Cada recarga acumula Azulzinhas — gire e ganhe até <b className="text-yellow-300">50.000 moedas!</b>
          </p>
        </div>
      </div>
      <span className="shrink-0 flex items-center gap-1.5 bg-yellow-400 text-blue-950 text-xs sm:text-sm font-black rounded-full px-3.5 py-1.5 shadow group-hover:bg-yellow-300 transition-colors">
        <Sparkles className="w-4 h-4" /> GIRAR
      </span>
    </div>
  </button>
);

const OilSlide = ({ navigate }) => (
  <button onClick={() => navigate('/tycoon')} data-testid="oil-home-banner"
    className="w-full group relative overflow-hidden rounded-2xl border border-amber-500/50 shadow-lg shadow-amber-900/30 transition-transform hover:scale-[1.01]">
    <img src="/oil/hero.webp" alt="" className="absolute inset-0 h-full w-full object-cover object-[center_22%]" />
    <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/30" />
    <div className="relative flex items-center justify-between gap-3 px-4 sm:px-6 py-3.5">
      <div className="flex items-center gap-3 text-left">
        <span className="text-4xl drop-shadow-lg" style={{ animation: 'oil-banner-bob 2.5s ease-in-out infinite' }}>🛢️</span>
        <div>
          <p className="text-white font-black text-sm sm:text-base leading-tight drop-shadow">
            OIL <span className="text-amber-400">TYCOON</span> <span className="text-[10px] align-middle rounded-full bg-amber-400 text-black px-1.5 py-0.5 font-black">SEASON ATIVA</span>
          </p>
          <p className="text-amber-100/90 text-[11px] sm:text-xs drop-shadow">
            Construa seu império do petróleo e dispute o <b className="text-amber-300">Jackpot dos Magnatas!</b>
          </p>
        </div>
      </div>
      <span className="shrink-0 flex items-center gap-1.5 bg-amber-400 text-black text-xs sm:text-sm font-black rounded-full px-3.5 py-1.5 shadow group-hover:bg-amber-300 transition-colors">
        ⛏️ JOGAR
      </span>
    </div>
  </button>
);

const ArenaSlide = ({ navigate, info }) => (
  <button onClick={() => navigate('/arena')} data-testid="arena-home-banner"
    className="w-full group relative overflow-hidden rounded-2xl border border-orange-500/50 shadow-lg shadow-purple-900/40 transition-transform hover:scale-[1.01]"
    style={{ background: 'linear-gradient(100deg, #1a0b2e 0%, #3b1054 55%, #14061f 100%)' }}>
    <img src="/gb/map_pumpkin.jpg" alt="" className="absolute inset-0 h-full w-full object-cover object-[center_35%] opacity-30" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#14061f]/90 via-[#1a0b2e]/70 to-transparent" />
    <div className="relative flex items-center justify-between gap-3 px-4 sm:px-6 py-3.5">
      <div className="flex items-center gap-3 text-left">
        <img src="/gb/mobile.png" alt="" className="w-12 h-12 object-contain drop-shadow-lg"
          style={{ animation: 'arena-banner-bob 2.6s ease-in-out infinite' }} />
        <div>
          <p className="text-white font-black text-sm sm:text-base leading-tight drop-shadow">
            {(info?.name || 'GB ARENA').toUpperCase()}{' '}
            <span className="text-[10px] align-middle rounded-full bg-orange-500 text-black px-1.5 py-0.5 font-black">NO AR</span>
          </p>
          <p className="text-purple-200/90 text-[11px] sm:text-xs drop-shadow">
            Suas recargas viram <b className="text-cyan-300">diamantes</b> — vença as {info?.nodes || 24} fases e
            <b className="text-orange-300"> ganhe mais diamantes!</b>
          </p>
        </div>
      </div>
      <span className="shrink-0 flex items-center gap-1.5 bg-orange-500 text-black text-xs sm:text-sm font-black rounded-full px-3.5 py-1.5 shadow group-hover:bg-orange-400 transition-colors">
        🎯 JOGAR
      </span>
    </div>
  </button>
);

const WitchSlide = ({ navigate, info }) => (
  <button onClick={() => navigate('/witch-balloon')} data-testid="wb-home-banner"
    className="w-full group relative overflow-hidden rounded-2xl border border-orange-400/60 shadow-lg shadow-purple-950/60 transition-transform hover:scale-[1.01]"
    style={{ background: 'linear-gradient(100deg, #0a0612 0%, #2e1065 55%, #0a0612 100%)' }}>
    <img src="/wb/bg.webp" alt="" className="absolute inset-0 h-full w-full object-cover object-[center_30%] opacity-45" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0a0612]/95 via-[#1a0b2e]/70 to-transparent" />
    <div className="relative flex items-center justify-between gap-3 px-4 sm:px-6 py-3.5">
      <div className="flex items-center gap-3 text-left">
        <img src="/wb/balloon.webp" alt="" className="w-12 h-12 object-contain drop-shadow-[0_0_10px_rgba(249,115,22,.8)]"
          style={{ animation: 'wb-banner-float 2.8s ease-in-out infinite' }} />
        <div>
          <p className="text-white font-black text-sm sm:text-base leading-tight drop-shadow">
            WITCH'S <span className="text-orange-400">BALLOON</span>{' '}
            <span className="whitespace-nowrap text-[10px] align-middle rounded-full bg-lime-400 text-black px-1.5 py-0.5 font-black">
              {info?.live ? 'NO AR' : 'EM BREVE'}
            </span>
          </p>
          <p className="text-purple-200/90 text-[11px] sm:text-xs drop-shadow">
            Cada 100.000 moedas recarregadas rendem Moedas da Bruxa — estoure balões e ganhe <b className="text-amber-300">até 50.000 moedas!</b>
          </p>
        </div>
      </div>
      <span className="shrink-0 flex items-center gap-1.5 bg-orange-500 text-black text-xs sm:text-sm font-black rounded-full px-3.5 py-1.5 shadow group-hover:bg-orange-400 transition-colors">
        🎃 JOGAR
      </span>
    </div>
  </button>
);

const MysterySlide = ({ navigate, info }) => (
  <button onClick={() => navigate('/bau-misterioso')} data-testid="mystery-home-banner"
    className="w-full group relative overflow-hidden rounded-2xl border border-fuchsia-400/60 shadow-lg shadow-purple-950/60 transition-transform hover:scale-[1.01]"
    style={{ background: 'linear-gradient(100deg, #12051f 0%, #4a1472 55%, #12051f 100%)' }}>
    <img src={mysteryBoxBg} alt="" className="absolute inset-0 h-full w-full object-cover object-center opacity-40" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#12051f]/95 via-[#2a0b45]/70 to-transparent" />
    <div className="relative flex items-center justify-between gap-3 px-4 sm:px-6 py-3.5">
      <div className="flex items-center gap-3 text-left">
        <img src={chestPurple} alt="" className="w-12 h-12 object-contain drop-shadow-[0_0_10px_rgba(217,70,239,.8)]"
          style={{ animation: 'mystery-banner-bob 2.6s ease-in-out infinite' }} />
        <div>
          <p className="text-white font-black text-sm sm:text-base leading-tight drop-shadow">
            BAÚ <span className="text-fuchsia-300">MISTERIOSO</span>{' '}
            <span className={`whitespace-nowrap text-[10px] align-middle rounded-full px-1.5 py-0.5 font-black ${info?.ended ? 'bg-rose-500 text-white' : 'bg-fuchsia-400 text-black'}`}>
              {info?.ended ? 'ENCERRADO' : 'NO AR'}
            </span>
          </p>
          <p className="text-purple-200/90 text-[11px] sm:text-xs drop-shadow">
            {info?.ended
              ? <>Edição encerrada — veja o <b className="text-fuchsia-300">ranking e os Top Sortudos</b> da semana</>
              : <>Bata as metas diárias de recarga e abra baús com <b className="text-fuchsia-300">prêmios misteriosos!</b></>}
          </p>
        </div>
      </div>
      <span className="shrink-0 flex items-center gap-1.5 bg-fuchsia-400 text-black text-xs sm:text-sm font-black rounded-full px-3.5 py-1.5 shadow group-hover:bg-fuchsia-300 transition-colors">
        {info?.ended ? '🏁 RESULTADOS' : '📦 ABRIR'}
      </span>
    </div>
  </button>
);

const RpSlide = ({ navigate, info }) => (
  <button onClick={() => navigate('/recarga-premiada')} data-testid="rp-home-banner"
    className="w-full group relative overflow-hidden rounded-2xl border border-amber-400/60 shadow-lg shadow-purple-950/60 transition-transform hover:scale-[1.01]"
    style={{ backgroundImage: 'linear-gradient(90deg, rgba(20,10,46,.85) 0%, rgba(59,7,100,.6) 55%, rgba(20,10,46,.85) 100%), url(/rp/bg.webp)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
    <div className="relative flex items-center justify-between gap-3 px-4 sm:px-6 py-3.5">
      <div className="flex items-center gap-3 text-left">
        <img src="/rp/chest.webp" alt="" className="h-14 w-14 object-contain drop-shadow-[0_0_10px_rgba(251,191,36,.8)]" style={{ animation: 'mystery-banner-bob 2.6s ease-in-out infinite' }} />
        <div>
          <p className="text-white font-black text-sm sm:text-base leading-tight drop-shadow">
            RECARGA <span className="text-amber-300">PREMIADA</span>{' '}
            <span className={`whitespace-nowrap text-[10px] align-middle rounded-full px-1.5 py-0.5 font-black ${info?.live ? 'bg-amber-300 text-black' : info?.upcoming ? 'bg-lime-400 text-black' : 'bg-rose-500 text-white'}`}>{info?.live ? 'NO AR' : info?.upcoming ? 'EM BREVE' : 'ENCERRADO'}</span>
          </p>
          <p className="text-purple-200/90 text-[11px] sm:text-xs drop-shadow">
            A cada <b className="text-amber-300">{Number(info?.coins_per_chest || 100000).toLocaleString('pt-BR')} moedas</b> um baú com presentes de 1.000 a <b className="text-amber-300">10.000</b> entregues na sua live 👻
          </p>
        </div>
      </div>
      <span className="shrink-0 flex items-center gap-1.5 bg-amber-300 text-black text-xs sm:text-sm font-black rounded-full px-3.5 py-1.5 shadow group-hover:bg-amber-200 transition-colors">{info?.upcoming ? '👀 VER' : '🎁 ABRIR'}</span>
    </div>
  </button>
);

export const EventBannerCarousel = () => {
  const navigate = useNavigate();
  const [rouletteActive, setRouletteActive] = useState(false);
  const [oilActive, setOilActive] = useState(false);
  const [arena, setArena] = useState(null);
  const [witch, setWitch] = useState(null);
  const [mystery, setMystery] = useState(null);
  const [rp, setRp] = useState(null);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    axios.get(`${API}/roulette/state`).then((r) => setRouletteActive(!!r.data?.active)).catch(() => {});
    axios.get(`${API}/oil/rankings`).then(() => setOilActive(true)).catch(() => {});
    axios.get(`${API}/gb/public`).then((r) => setArena(r.data?.active ? r.data : null)).catch(() => {});
    axios.get(`${API}/wb/state`).then((r) => setWitch(r.data?.event ? { live: !!r.data.live } : null)).catch(() => {});
    axios.get(`${API}/rp/state`).then((r) => setRp(r.data?.event || null)).catch(() => {});
    axios.get(`${API}/mystery-box/public-status`).then((r) => setMystery(r.data?.visible ? r.data : null)).catch(() => {});
  }, []);

  const slides = useMemo(() => {
    const s = [];
    if (witch) s.push('witch');
    if (rouletteActive) s.push('roulette');
    if (oilActive) s.push('oil');
    if (arena) s.push('arena');
    if (mystery) s.push('mystery');
    if (rp?.live || rp?.upcoming) s.unshift('rp'); // encerrado (manual ou na data) some da Home; programado = EM BREVE
    return s;
  }, [witch, rouletteActive, oilActive, arena, mystery, rp]);

  useEffect(() => {
    if (slides.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % slides.length), 9000);
    return () => clearInterval(t);
  }, [slides.length]);

  if (slides.length === 0) return null;
  const current = slides[idx % slides.length];

  return (
    <div className="mb-4" data-testid="event-banner-carousel">
      <style>{`
        @keyframes banner-wheel-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes oil-banner-bob { 0%,100% { transform: translateY(0) rotate(-4deg); } 50% { transform: translateY(-4px) rotate(4deg); } }
        @keyframes arena-banner-bob { 0%,100% { transform: translateY(0) rotate(-3deg); } 50% { transform: translateY(-5px) rotate(3deg); } }
        @keyframes wb-banner-float { 0%,100% { transform: translateY(0) rotate(-5deg) scale(1); } 50% { transform: translateY(-6px) rotate(5deg) scale(1.06); } }
        @keyframes mystery-banner-bob { 0%,100% { transform: translateY(0) rotate(-4deg); } 50% { transform: translateY(-5px) rotate(4deg); } }
        @keyframes event-slide-in { from { opacity: 0; transform: translateX(24px); } to { opacity: 1; transform: translateX(0); } }
      `}</style>
      <div key={current} style={{ animation: slides.length > 1 ? 'event-slide-in 0.5s ease-out' : 'none' }}>
        {current === 'witch' ? <WitchSlide navigate={navigate} info={witch} />
          : current === 'roulette' ? <RouletteSlide navigate={navigate} />
          : current === 'oil' ? <OilSlide navigate={navigate} />
          : current === 'mystery' ? <MysterySlide navigate={navigate} info={mystery} />
          : current === 'rp' ? <RpSlide navigate={navigate} info={rp} />
            : <ArenaSlide navigate={navigate} info={arena} />}
      </div>
      {slides.length > 1 && (
        <div className="mt-1.5 flex justify-center gap-1.5" data-testid="event-banner-dots">
          {slides.map((s, i) => (
            <button key={s} onClick={() => setIdx(i)} aria-label={`banner ${i + 1}`}
              className={`h-1.5 rounded-full transition-all duration-300 ${i === idx % slides.length ? 'w-5 bg-yellow-400' : 'w-1.5 bg-slate-500/50'}`} />
          ))}
        </div>
      )}
    </div>
  );
};

export default EventBannerCarousel;
